import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61241c80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reissue-type-wrap" }
const _hoisted_2 = { class: "reissue-type-list-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "right-wrap" }
const _hoisted_6 = { class: "bottom-wrap xag-page__footer" }

import { CheckboxGroup, Checkbox, Button } from 'vant'
import { ref, withDefaults, computed } from 'vue'
export interface ReissueTypeListItemType {
  value: string
  label: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'reissue-type-list',
  props: {
    data: null,
    checked: null
  },
  emits: ["confirm", "update:checked"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'confirm', value: Array<string>): void
  (event: 'update:checked', value: Array<string>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { data: Array<ReissueTypeListItemType>, checked: Array<string> };





let checked = computed({
  get() {
    return props.checked
  },
  set(value) {
    emit('update:checked', value)
  },
})

let data = computed(() => {
  return props.data
})

function clickHandle(item: ReissueTypeListItemType) {
  if (checked.value.includes(item.value)) {
    checked.value = checked.value.filter((_) => _ !== item.value)
  } else {
    checked.value.push(item.value)
  }
}
function confirmHandle() {
  emit('confirm', checked.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "reissue-type-list-item van-hairline--bottom",
            key: index,
            onClick: ($event: any) => (clickHandle(item))
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (clickHandle(item))
            }, [
              _createVNode(_unref(CheckboxGroup), {
                modelValue: _unref(checked),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : checked = $event)),
                direction: "horizontal",
                "checked-color": "rgba(0, 195, 120, 1)",
                class: "radio-group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Checkbox), {
                    name: item.value
                  }, null, 8, ["name"])
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ], 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(item.label), 1)
            ])
          ], 8, _hoisted_3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(Button), {
        class: "ok-button",
        color: "rgba(0, 195, 120, 1)",
        onClick: confirmHandle
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})